<template>
    <div>
        <label class="switch">
            <input type="checkbox" v-bind:checked="value" v-on:click.stop.prevent="onSwitchClicked($event);">
            <span v-on:click.stop.prevent="onSwitchClicked($event);"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: "SwitchControl",
    props: {
        value: Boolean
    },
    data() {
        return {
            checkedState: false
        }
    },
    watch: {
        checkedState: function() {
            this.$emit("input", this.checkedState);
        }
    },
    methods: {
        onSwitchClicked: function(event) {
            this.checkedState = !this.checkedState;
            this.$emit("click", this.checkedState);
            this.$emit("input", event.target.value == "true");
            event.stopPropagation();
        }
    },
    mounted() {
        this.checkedState = this.value;
    }
}
</script>

<style scoped>
label {
    margin-bottom: 0px;
}

label.switch { 
    text-align: left;
    width: 50px;
    height: calc(50px / 2);
    border-radius:50px;   
    background-color:#4ed164;
    display: inline-block;
    position: relative;
    cursor: pointer;
}

label.switch > span {
    display: block;
    width: 100%;
    height: 100%;
}

label.switch > input[type="checkbox"] {
    opacity: 0;
    position: absolute;
}

label.switch > span:before, label.switch > span:after {
    content: "";
    cursor: pointer;
    position: absolute;
}

label.switch > input[type="checkbox"]:focus ~ span {
    box-shadow: 0 0 0 1px #43b556;
}

label.switch > input[type="checkbox"]:checked:focus ~ span {
    box-shadow: 0 0 0 1px #fff;
}

label.switch > span {
    border-radius: 60px;   
}

label.switch > span:before {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #f1f1f1;
    border-radius: 50px;
    transition: opacity .2s ease-out .1s, transform .2s ease-out .1s;
    transform: scale(1);
    opacity: 1;
}

label.switch > span:after{
    top: 50%;
    z-index: 3;
    transition: transform .4s cubic-bezier(0.44,-0.12, 0.07, 1.15);
    width: calc(50px / 2);
    height: calc(50px / 2);
    transform: translate3d(0, -50%, 0);
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .3); 
}

label.switch > input[type="checkbox"]:checked ~ span:before {
    transform: scale(0);
    opacity: .7;
}

label.switch > input[type="checkbox"]:checked ~ span:after {
    transform: translate3d(100%, -50%, 0);
}
</style>